export class UserRole {
    id?: number;
    name?: string;
    title?: string;

    static fromJson(fields: any): UserRole {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
